module.exports = __webpack_public_path__ + "img/day-jobber.c27094c8.png";